import { Skeleton } from "antd";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import Page from "../../Common/Page";
import { useFetchStandingConfiguration } from "../../entities/api";
import ManageStandingConfigurationsForm from "./ManageStandingConfigurationsForm";

const ManageStandingConfigurations = () => {
  const { formatMessage } = useIntl();
  const { standingConfigurationId } = useParams();
  const { data: standingConfiguration, isLoading: isFetchLoading } = useFetchStandingConfiguration();

  if (standingConfigurationId && isFetchLoading) {
    return <Skeleton />;
  }

  const TITLE = standingConfiguration
    ? formatMessage({
        id: "manage",
        defaultMessage: "Manage",
      }) +
      " - " +
      standingConfiguration?.nameLocal
    : formatMessage({
        id: "standings.configuration.add",
        defaultMessage: "Adding a New Standings Configuration",
      });

  return (
    <Page title={TITLE} tabTitle={TITLE}>
      <ManageStandingConfigurationsForm standingConfiguration={standingConfiguration} />
    </Page>
  );
};

export default ManageStandingConfigurations;
